var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.90039,
    width: 1.60001,
    height: 0.800004,
    fill: "#232323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.09961,
    y: 0.800293,
    width: 0.800004,
    height: 8.80004,
    fill: "#232323"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.50049,
    y: 0.800293,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.30029,
    y: 5.59985,
    width: 1.60001,
    height: 0.800004,
    fill: "#232323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.90039,
    y: 6.40015,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7002,
    y: 7.19995,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1001,
    y: 8.80029,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90039,
    y: 14.4001,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.09961,
    y: 13.6001,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 4.30029,
    y: 12.8,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.50146,
    y: 12,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 2.7002,
    y: 11.2,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1.8999,
    y: 10.4001,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1.09912,
    y: 9.6001,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 0.300293,
    y: 8,
    width: 0.800004,
    height: 1.60001,
    fill: "#232323"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1.09912,
    y: 7.19995,
    width: 1.60001,
    height: 0.800004,
    fill: "#232323"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 4.30029,
    y: 8.80029,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 3.50146,
    y: 8,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 2.7002,
    y: 7.19995,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1001,
    y: 14.4001,
    width: 0.800004,
    height: 0.800004,
    fill: "#232323"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6.7002,
    y: 15.2,
    width: 6.40003,
    height: 0.800004,
    fill: "#232323"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9009,
    y: 9.6001,
    width: 0.800004,
    height: 4.80002,
    fill: "#232323"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5005,
    y: 8,
    width: 1.60001,
    height: 0.800004,
    fill: "#232323"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 7.50049,
    y: 1.59985,
    width: 0.800004,
    height: 4.80002,
    fill: "#232323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.4ce483484ac8e852d09be540229c34f8.svg";
export { ForwardRef as ReactComponent };